module.exports = __webpack_public_path__ + "img/01.96deae43.jpg";